/** Pure barrel — re-exports only side-effect-free modules */
/* eslint-disable @typescript-eslint/no-restricted-imports */
export * from "./2D/pure";
export * from "./3D/pure";
